import { render, staticRenderFns } from "./u-btn-outlined-tile.vue?vue&type=template&id=098999a6&scoped=true"
import script from "./u-btn-outlined-tile.vue?vue&type=script&lang=js"
export * from "./u-btn-outlined-tile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "098999a6",
  null
  
)

export default component.exports